module.exports = __webpack_public_path__ + "img/upload-icon-white.101abc75.svg";